import styled from "vue-styled-components";

const propsPopUp = {
    justifyContentPopUp: { default: '', type: String },
    alignItemsPopUp:     { default: '', type: String },
    marginPopUp:         { default: '', type: [String, Number] },
    maxWidth:            { default: '', type: String },
    maxHeight:           { default: '', type: String },
    backgroundColor:     { default: '', type: String },
    boxShadow: {
        default: '0 0 12px 2px rgba(0, 0, 0, 0.35)',
        type: String
    },

    // HEADER
    paddingPopUpHeader:     { default: '', type: [String, Number] },
    borderWidthPopUpHeader: { default: '', type: [String, Number] },
    borderColorPopUpHeader: { default: '', type: String },
    borderStylePopUpHeader: { default: '', type: String },

    // BODY
    paddingPopUpBody:      { default: '', type: [String, Number] },
    flexDirectionContent:  { default: '', type: String },
    alignItemsContent:     { default: '', type: String },
    justifyContentContent: { default: '', type: String },
    paddingContent:        { default: '', type: [String, Number] },
    overflowBodyPopUp:     { default: '', type: String },

    // FOOTER
    paddingPopUpFooter:        { default: '', type: [String, Number] },
    justifyContentPopUpFooter: { default: '', type: String },
    borderWidthPopUpFooter:    { default: '', type: [String, Number] },
    borderColorPopUpFooter:    { default: '', type: String },
    borderStylePopUpFooter:    { default: '', type: String },

    // TITLE
    textAlignTitle:     { default: '', type: String },
    textTransformTitle: { default: '', type: String },
    fontSizeTitle:      { default: '', type: String },
    fontWeightTitle:    { default: '', type: String },
    fontFamilyTitle:    { default: '', type: String },
    colorTitle:         { default: '', type: String },
    whiteSpaceTitle:    { default: '', type: String },
    marginTitle:        { default: '', type: [String, Number] },
    letterSpacingTitle: { default: '', type: [String, Number] },
    lineHeightTitle:    { default: '', type: [String, Number] },
    
    // DESCRIPTION
    textAlignDescription:     { default: '', type: String },
    textTransformDescription: { default: '', type: String },
    fontSizeDescription:      { default: '', type: String },
    fontWeightDescription:    { default: '', type: String },
    fontFamilyDescription:    { default: '', type: String },
    colorDescription:         { default: '', type: String },
    marginDescription:        { default: '', type: [String, Number] },
    letterSpacingDescription: { default: '', type: [String, Number] },
    lineHeightDescription:    { default: '', type: [String, Number] },

    // BUTTONS
    borderWidthButton:   { default: '', type: [String, Number] },
    borderStyleButton:   { default: '', type: String },
    borderRadiusButton:  { default: '', type: [String, Number] },
    fontSizeButton:      { default: '', type: String },
    fontWeightButton:    { default: '', type: String },
    fontFamilyButton:    { default: '', type: String },
    textTransformButton: { default: '', type: String },
    letterSpacingButton: { default: '', type: [String, Number] },
    paddingButton:       { default: '', type: [String, Number] },
    marginButton:        { default: '', type: [String, Number] },
    // Btn yes
    bgBtnYes:               { default: '', type: String },
    colorBtnYes:            { default: '', type: String },
    borderColorBtnYes:      { default: '', type: String },
    bgHoverBtnYes:          { default: '', type: String },
    colorHoverBtnYes:       { default: '', type: String },
    borderHoverColorBtnYes: { default: '', type: String },
    // Btn no
    bgBtnNo:               { default: '', type: String },
    colorBtnNo:            { default: '', type: String },
    borderColorBtnNo:      { default: '', type: String },
    bgHoverBtnNo:          { default: '', type: String },
    colorHoverBtnNo:       { default: '', type: String },
    borderHoverColorBtnNo: { default: '', type: String },
    // Btn sign
    bgBtnSign:               { default: '', type: String },
    colorBtnSign:            { default: '', type: String },
    borderColorBtnSign:      { default: '', type: String },
    bgHoverBtnSign:          { default: '', type: String },
    colorHoverBtnSign:       { default: '', type: String },
    borderHoverColorBtnSign: { default: '', type: String },

    // INPUT
    bgInput:            { default: '', type: String },
    colorInput:         { default: '', type: String },
    fontSizeInput:      { default: '', type: String },
    fontWeightInput:    { default: '', type: String },
    letterSpacingInput: { default: '', type: [String, Number] },
    paddingInput:       { default: '', type: String },
    marginInput:        { default: '', type: [String, Number] },
    borderRadiusInput:  { default: '', type: [String, Number] },
    borderWidthInput:   { default: '', type: [String, Number] },
    borderStyleInput:   { default: '', type: String },
    borderColorInput:   { default: '', type: String },
}

export const CPopUpModalContent = styled('div', propsPopUp)`
    > .modal {
        background-color: rgba(0,0,0,.7);
        display: flex;
        justify-content: ${props => props.justifyContentPopUp};
        align-items: ${props => props.alignItemsPopUp};
        overflow: auto;

        > .modal-dialog {
            max-width: ${props => props.maxWidth};
            margin: ${props => props.marginPopUp};

            > .modal-content {
                max-height: ${props => props.maxHeight};
                /* border-radius: ${props => props.borderRadius}; */
                box-shadow: ${props => props.boxShadow};
                background-color: ${props => props.backgroundColor};
                border: 1px solid rgba(0,0,0,.2);

                margin-top: 0;
                margin-bottom: 0;
                
                /* > .modal-header {
                    padding: ${props => !props.paddingPopUpHeader ? '10px 15px' : props.paddingPopUpHeader};

                    height: auto;
                    border-width: ${props => props.borderWidthPopUpHeader};
                    border-style: ${props => props.borderStylePopUpHeader};
                    border-color: ${props => props.borderColorPopUpHeader};

                    > h3 {
                        margin: ${props => !props.marginTitle ? '0' : props.marginTitle};
                        text-align: ${props => !props.textAlignTitle ? 'left' : props.textAlignTitle};
                        color: ${props => !props.colorTitle ? props.theme.primary_color : props.colorTitle};
                        font-family: ${props => !props.fontFamilyTitle ? 'Oswald' : props.fontFamilyTitle}, sans-serif;
                        font-size: ${props => !props.fontSizeTitle ? '1.8rem' : props.fontSizeTitle};
                        text-transform: ${props => !props.textTransformTitle ? 'initial' : props.textTransformTitle};
                        white-space: ${props => !props.whiteSpaceTitle ? 'wrap' : props.whiteSpaceTitle};
                        font-weight: ${props => !props.fontWeightTitle ? '700' : props.fontWeightTitle};

                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                } */

                > i.fas.fa-times {
                    position: absolute;
                    right: 0;
                    top: 0;
                    z-index: 9;
                    padding: 10px;
                    cursor: pointer;
                }

                > .modal-body {
                    position: relative;
                    padding: ${props => props.paddingPopUpBody};
                    overflow: ${props => props.overflowBodyPopUp};
                    max-height: none;

                    /* > img {
                        max-width: none;
                    } */

                    > .news-header {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        z-index: 100;
                        padding: ${props => props.paddingPopUpHeader};
                    }

                    /* > img.all + .pop-up-content.all {
                        position: absolute;
                        top: 0px;
                        left: 0px;
                        right: 0px;
                        bottom: 0px;
                        z-index: 99;
                    } */

                    > img.float-left.w-25 + .pop-up-content.float-right.w-75 { position: absolute; left: 25%; top: 0%; bottom: 0%; }
                    > img.float-left.w-50 + .pop-up-content.float-right.w-50 { position: absolute; left: 50%; top: 0%; bottom: 0%; }
                    > img.float-left.w-75 + .pop-up-content.float-right.w-25 { position: absolute; left: 75%; top: 0%; bottom: 0%; }
                    > img.all.w-100 + .pop-up-content.all.w-100 { position: absolute; left: 0%; top: 0%; }
                    > img.float-right.w-75 + .pop-up-content.float-left.w-25 { position: absolute; left: 0%; top: 0%; bottom: 0%; }
                    > img.float-right.w-50 + .pop-up-content.float-left.w-50 { position: absolute; left: 0%; top: 0%; bottom: 0%; }
                    > img.float-right.w-25 + .pop-up-content.float-left.w-75 { position: absolute; left: 0%; top: 0%; bottom: 0%; }

                    > img.float-right + .pop-up-content.float-right { position: absolute; right: 0% }
                    > img.float-left + .pop-up-content.float-left { position: absolute; left: 0% }

                    > .pop-up-content.float-left.w-100,
                    > .pop-up-content.float-right.w-100,
                    > .pop-up-content.float-left.w-75,
                    > .pop-up-content.float-right.w-75,
                    > .pop-up-content.float-left.w-50,
                    > .pop-up-content.float-right.w-50,
                    > .pop-up-content.float-left.w-25, 
                    > .pop-up-content.float-right.w-25 {
                        position: relative;
                    }

                    > .pop-up-content {
                        padding: ${props => props.paddingContent};
                        height: 100%;
                        display: flex;
                        flex-direction: ${props => props.flexDirectionContent};
                        align-items: ${props => props.alignItemsContent};
                        justify-content: ${props => props.justifyContentContent};

                        > h3 {
                            text-align: ${props => props.textAlignTitle};
                            color: ${props => props.colorTitle};
                            font-family: ${props => props.fontFamilyTitle}, sans-serif;
                            font-size: ${props => props.fontSizeTitle};
                            text-transform: ${props => props.textTransformTitle};
                            white-space: ${props => props.whiteSpaceTitle};
                            font-weight: ${props => props.fontWeightTitle};
                            margin: ${props => props.marginTitle};
                            letter-spacing: ${props => props.letterSpacingTitle};
                            line-height: ${props => props.lineHeightTitle};
                         
                            width: 100%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }

                        > .div-description {
                            margin: ${props => props.marginDescription};
                            text-align: ${props => props.textAlignDescription};
                            color: ${props => props.colorDescription};
                            font-family: ${props => props.fontFamilyDescription}, sans-serif;
                            font-size: ${props => props.fontSizeDescription};
                            text-transform: ${props => props.textTransformDescription};
                            font-weight: ${props => props.fontWeightDescription};
                            letter-spacing: ${props => props.letterSpacingDescription};
                            line-height: ${props => props.lineHeightDescription};
                            width: 100%;
                        }

                        /* > .div-description + .form-group {
                            margin-top: 30px;
                        } */

                        > .form-group {
                            display: flex;
                            /* justify-content: space-between; */
                            align-items: flex-end;
                            margin: ${props => props.marginInput};
        
                            > div {
                                padding-right: 0;
                                padding-left: 0;
                                > input {
                                    border-width: ${props => props.borderWidthInput};
                                    border-style: ${props => props.borderStyleInput};
                                    border-color: ${props => props.borderColorInput};
                                    border-radius: ${props => props.borderRadiusInput};

                                    font-size: ${props => props.fontSizeInput};
                                    font-weight: ${props => props.fontWeightInput};

                                    text-overflow: ellipsis;
                                    width: 100%;
                                    background-color: ${props => props.bgInput};
                                    color: ${props => props.colorInput};
                                    padding: ${props => props.paddingInput};
                                    outline: none;
                                    font-family: ${props => props.fontFamilyDescription}, sans-serif;
                                    letter-spacing: ${props => props.letterSpacingInput};

                                    &:-webkit-autofill:focus {
                                        background-color: ${props => props.bgInput};
                                    }
                                }
                            }

                            > button {
                                padding: ${props => props.paddingButton};
                                text-transform: ${props => props.textTransformButton};
                                border-radius: ${props => props.borderRadiusButton};
                                border-width: ${props => props.borderWidthButton};
                                border-style: ${props => props.borderStyleButton};
                                margin: ${props => props.marginButton};
                                font-size: ${props => props.fontSizeButton};
                                font-family: ${props => props.fontFamilyButton};
                                font-weight: ${props => props.fontWeightButton};
                                letter-spacing: ${props => props.letterSpacingButton};

                                transition: all .3s linear;
                                cursor: pointer;
                                
                                &.btn-sign {
                                    background-color: ${props => props.bgBtnSign};
                                    border-color: ${props => props.borderColorBtnSign};
                                    color: ${props => props.colorBtnSign};
                                    &:hover {
                                        background-color: ${props => props.bgHoverBtnSign};
                                        border-color: ${props => props.borderHoverColorBtnSign};
                                        color: ${props => props.colorHoverBtnSign};
                                    }
                                }
                            }
                        }
                    }

                    
                }

                > .modal-footer {
                    padding: ${props => props.paddingPopUpFooter};
                    justify-content: ${props => props.justifyContentPopUpFooter};

                    display: flex;
                    flex-wrap: wrap;
                    height: auto;
                    border-width: ${props => props.borderWidthPopUpFooter};
                    border-style: ${props => props.borderStylePopUpFooter};
                    border-color: ${props => props.borderColorPopUpFooter};
                    /* overflow: hidden; */

                    > button, a button {
                        padding: ${props => props.paddingButton};
                        text-transform: ${props => props.textTransformButton};
                        border-radius: ${props => props.borderRadiusButton};
                        border-width: ${props => props.borderWidthButton};
                        border-style: ${props => props.borderStyleButton};
                        margin: ${props => props.marginButton};
                        font-size: ${props => props.fontSizeButton};
                        font-family: ${props => props.fontFamilyButton};
                        font-weight: ${props => props.fontWeightButton};
                        letter-spacing: ${props => props.letterSpacingButton};

                        transition: all .3s linear;
                        cursor: pointer;
                        outline: none;

                        &.btn-yes {
                            background-color: ${props => props.bgBtnYes};
                            color: ${props => props.colorBtnYes};
                            border-color: ${props => props.borderColorBtnYes};
                            > a {
                                color: ${props => props.colorBtnYes};
                                text-decoration: none;
                                &:hover {
                                    color: ${props => props.colorHoverBtnYes};
                                }
                            }
                            &:hover {
                                background-color: ${props => props.bgHoverBtnYes};
                                border-color: ${props => props.borderHoverColorBtnYes};
                                color: ${props => props.colorHoverBtnYes};
                            }
                        }
                        &.btn-no {
                            background-color: ${props => props.bgBtnNo};
                            color: ${props => props.colorBtnNo};
                            border-color: ${props => props.borderColorBtnNo};
                            > a {
                                color: ${props => props.colorBtnNo};
                                text-decoration: none;
                                &:hover {
                                    color: ${props => props.colorHoverBtnNo};
                                }
                            }
                            &:hover {
                                background-color: ${props => props.bgHoverBtnNo};
                                border-color: ${props => props.borderHoverColorBtnNo};
                                color: ${props => props.colorHoverBtnNo};
                            }
                        }
                    }
                }
            }
        }
    }

    @media (max-width: 645px) {
        > .modal {
            > .modal-dialog {
                margin: 5px;
            }
            &.modal-coupon {
                > .modal-dialog {
                    margin: 100px 5px 5px 5px;
                }
            }
        }
    }
`